// Copyright (c) 2024 by Audere

import { Controller, useFormContext } from "react-hook-form";
import React, { useCallback } from "react";

import { TextField } from "@mui/material";
import { TextQuestion } from "../features/label/labelTypes";
import { debounceForDataChange } from "../utils/taskUtils";
import { validateQuestion } from "../utils/validateQuestion";

interface TextQuestionComponentProps {
  name: string;
  question: TextQuestion;
  onChangeEvent: () => void;
}

const TextQuestionComponent: React.FC<TextQuestionComponentProps> = ({
  name,
  question,
  onChangeEvent,
}) => {
  const { control } = useFormContext();

  const validateFn = useCallback(
    (value: string) =>
      validateQuestion(question, { response: value, requiredComment: "" }) ||
      "This field is required.",
    [question]
  );

  return (
    <Controller
      name={`${name}.response`}
      control={control}
      defaultValue=""
      rules={{ validate: validateFn }}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          onBlur={() => {
            field.onBlur();
            onChangeEvent();
          }}
          onChange={(e) => {
            field.onChange(e);
            debounceForDataChange(onChangeEvent);
          }}
          error={!!fieldState.error}
          helperText={fieldState.error ? fieldState.error.message : ""}
          multiline
          fullWidth
        />
      )}
    />
  );
};

// Memoized to re-render only when props change
export default React.memo(TextQuestionComponent);
